import { TextFieldProps } from '@material-ui/core/TextField';
import { createKeyPath } from 'CMFW/context/helper/keyContext';
import KeyContext from 'CMFW/context/KeyContext';
import ModuleContext from 'CMFW/context/ModuleContext';
import { TextFieldChangeAware } from 'components/common/styles';
import { useCurrentItemValue } from 'hooks/useCurrentItemValue';
import { omit } from 'lodash';
import React, { useContext, useEffect } from 'react';

type IProps = TextFieldProps & {
  keyName: string;
};

const TextInput: React.FC<IProps> = (props) => {
  const parentKey = useContext(KeyContext);
  const aggregatedKeyName = createKeyPath(parentKey, props.keyName);

  const module = useContext(ModuleContext);
  const moduleItemValue: string = module.getItemValue.bind(module)(aggregatedKeyName) ?? '';
  const moduleItemValueUpdated: string = module.getItemUpdatedValue(aggregatedKeyName) ?? '';

  const [currentValue, setCurrentValue] = useCurrentItemValue(moduleItemValue, '');

  useEffect(() => {
    setCurrentValue(moduleItemValueUpdated);
  }, [moduleItemValueUpdated, setCurrentValue]);

  const onChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setCurrentValue(event.target.value);
    module.updateItemValue.bind(module)(aggregatedKeyName, event.target.value);
  };

  return (
    <TextFieldChangeAware
      value={currentValue}
      {...omit(props, ['keyName'])}
      $changed={moduleItemValue !== currentValue}
      variant="outlined"
      onChange={onChange}
    />
  );
};

export default TextInput;
